<div class="container">
    <div class="alert alert-danger" *ngIf="isError">{{errorMessage}}</div>
</div>
